import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/sncRules": {
        title: "SNC Rules",
        authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/:sncRuleId": {
            title: "SNC Rule Detail"
        }
    }
};
